import React from 'react';

import { ColumnWrapper } from './ColumnWrapper';
import Shimmer from '../../../common/Shimmer';

import styles from '../css/CoveragePPUInfoFee.module.css';

export const CoveragePPUInfoFeeShimmer = () => (
  <ColumnWrapper>
    <Shimmer className={styles.shimmer} visible />

    <Shimmer className={styles.shimmer} visible />

    <Shimmer className={styles.shimmer} visible />

    <Shimmer className={styles.shimmer} visible />
  </ColumnWrapper>
);
